import { render, staticRenderFns } from "./TableVisitorsCalendar.vue?vue&type=template&id=38db3954&scoped=true&"
import script from "./TableVisitorsCalendar.vue?vue&type=script&lang=ts&"
export * from "./TableVisitorsCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./TableVisitorsCalendar.vue?vue&type=style&index=0&id=38db3954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db3954",
  null
  
)

component.options.__file = "TableVisitorsCalendar.vue"
export default component.exports